import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@components/svg-icon/svg-icon';

import { Info } from '@helpers/icon-dictionary';

import {
  InfoIcon,
  InfoTooltip,
  OptionWrapper,
  InfoTooltipText,
  FilterOption
} from './styled';

const IconOption = ({ handleSelection, filter, id, labelText, infoText }) => (
  <OptionWrapper>
    <FilterOption
      data-testid={id}
      onClick={() => handleSelection(id)}
      selected={filter === id}
    >
      {labelText}
    </FilterOption>
    <InfoIcon>
      <SvgIcon
        icon={Info}
      />
      <InfoTooltip>
        <InfoTooltipText>
          {infoText}
        </InfoTooltipText>
      </InfoTooltip>
    </InfoIcon>
  </OptionWrapper>
)

IconOption.propTypes = {
  filter: PropTypes.string.isRequired,
  handleSelection: PropTypes.func.isRequired,
  id: PropTypes.string,
  labelText: PropTypes.string,
  infoText: PropTypes.string
};

export default IconOption;
